import { DropDownFilter } from 'framework/list';
import PositionWithTechnologyDropdown from 'domain/shared/employee/position/input/PositionWithTechnologyDropdown';
import { Box } from '@mui/material';
import { useShowContext } from 'framework/show';

const EmployeeSpecializationFilter = ({ technologyProps, ...props }: any) => {
  const { data } = useShowContext();
  const options = data?.allSpecializations;
  return (
    <Box
      sx={{
        '& [data-testId="remove-btn"], & .filters-reset-btn': {
          display: 'none',
        },
      }}
    >
      <DropDownFilter isSingle {...props}>
        <PositionWithTechnologyDropdown {...props} providedOptions={options} />
      </DropDownFilter>
    </Box>
  );
};

export default EmployeeSpecializationFilter;
